import messageResource from '../../../../js/messageResource'
import {DateFormat} from '../../../../js/date_format'
import UserNameFormat from '../../../../js/util/UserNameFormat'
import {arrayToMap} from '../../../../js/atUtils'
import {downloadJsonAsCSV} from '../../../../js/csv/utils'
import LeaveTypeStore from '../../../../js/store/LeaveTypeStore'
import BalanceType from '../../../../js/enums/BalanceType'
import NumberFormatter from '../../../../js/number_formatter'

export default class CSVConverter {
    constructor() {
        this.dateFormatter = new DateFormat(window.SystemSettings.dateFormat)
        this.numberFormatter = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, true)
        this.usersMap = arrayToMap(window.APReportsStore.getVisibleUsers())
    }

    convertAndSaveAsCSV({
        workHoursPerDay,
        selectedUserId,
        dateFrom,
        period,
        requests,
        showBalances,
        showComments,
        spinner
    }) {
        this.workHoursPerDay = workHoursPerDay
        const json = {
            columnNames: this.getColumnNames(),
            columns: this.getColumns(showBalances, showComments),
            table: this.getRows(requests)
        }

        downloadJsonAsCSV([json], this.getFilename(selectedUserId, dateFrom, period), () => spinner.stop())
    }

    getColumnNames() {
        return {
            leaveType: messageResource.getMessage('actiplans.leave_time_requests.leave_type'),
            startDate: messageResource.getMessage('common.start_date'),
            endDate: messageResource.getMessage('common.end_date'),
            timeRequestedD: messageResource.getMessage('actiplans.leave_time_requests.time_requested_with_units',
                [messageResource.getMessage('common.balance_units.days.short')]),
            timeRequestedH: messageResource.getMessage('actiplans.leave_time_requests.time_requested_with_units',
                [messageResource.getMessage('common.balance_units.hours.short')]),
            balanceType: messageResource.getMessage('actiplans.leave_time_requests.balance_type'),
            balanceBeforeD: messageResource.getMessage('actiplans.leave_time_requests.balance_before',
                [messageResource.getMessage('common.balance_units.days.short')]),
            balanceAfterD: messageResource.getMessage('actiplans.leave_time_requests.balance_after',
                [messageResource.getMessage('common.balance_units.days.short')]),
            balanceBeforeH: messageResource.getMessage('actiplans.leave_time_requests.balance_before',
                [messageResource.getMessage('common.balance_units.hours.short')]),
            balanceAfterH: messageResource.getMessage('actiplans.leave_time_requests.balance_after',
                [messageResource.getMessage('common.balance_units.hours.short')]),
            comment: messageResource.getMessage('common.Comment'),
            status: messageResource.getMessage('actiplans.leave_time_requests.status'),
            statusNote: messageResource.getMessage('actiplans.leave_time_requests.status_note'),
        }
    }

    getColumns(showBalances, showComments) {
        return ['leaveType', 'startDate', 'endDate', 'timeRequestedD', 'timeRequestedH',
                ...showBalances ? ['balanceType', 'balanceBeforeD', 'balanceAfterD', 'balanceBeforeH', 'balanceAfterH'] : [],
                ...showComments ? ['comment'] : [],
                'status', 'statusNote']
    }

    getRows(requests) {
        return requests.map(request => {
            const leaveType = LeaveTypeStore.getLeaveType(request.leaveTypeId)
            return {
                leaveType: leaveType.name + (leaveType.active ? '' : ` ${messageResource.getMessage('common.archived')}`),
                startDate: this.dateFormatter.formatDate(Date.parseJSONDate(request.firstDate)),
                endDate: this.dateFormatter.formatDate(Date.parseJSONDate(request.lastDate)),
                timeRequestedD: this.numberFormatter.format(request.leaveTimeTotal.days),
                timeRequestedH: this.numberFormatter.format(request.leaveTimeTotal.hours),
                comment: request.comment ? request.comment : '-',
                status: messageResource.getMessage('actiplans.request_status.approved'),
                statusNote: this.getStatusNote(request),
                ...this.getBalanceInfo(request.balanceData, leaveType.balanceType)
            }
        })
    }

    getStatusNote(request) {
        const dateText = this.dateFormatter.formatDate(Date.parseJSONDate(request.statusDate))
        const approverText = request.approverInfo
                             ? messageResource.getMessage('actiplans.request_status.by_user',
                [UserNameFormat.formatFML(request.approverInfo.firstName, request.approverInfo.lastName, request.approverInfo.middleInitial)])
                             : messageResource.getMessage('actiplans.request_status.automatic_approval')
        return `${dateText}, ${approverText}`
    }

    getBalanceInfo(balanceData, balanceType) {
        const affectsBalance = balanceData && balanceData.balanceChangeData
        if (affectsBalance && (window.SystemSettings.apPtoBalanceCalculationEnabled || window.SystemSettings.apSickBalanceCalculationEnabled)) {
            if (balanceType === BalanceType.PTO && window.SystemSettings.apPtoBalanceCalculationEnabled) {
                return {
                    balanceType: messageResource.getMessage('common.balance_history.table.pto'),
                    ...this.getBalanceValues(balanceData)
                }
            } else if (balanceType === BalanceType.SICK && window.SystemSettings.apSickBalanceCalculationEnabled) {
                return {
                    balanceType: messageResource.getMessage('common.balance_history.table.sick'),
                    ...this.getBalanceValues(balanceData)
                }
            }
        } else {
            return {
                balanceType: '-',
                balanceBeforeD: '-',
                balanceAfterD: '-',
                balanceBeforeH: '-',
                balanceAfterH: '-',
            }
        }
    }

    getBalanceValues(balanceData) {
        return {
            balanceBeforeD: this.numberFormatter.format(balanceData.balanceChangeData.startBalance),
            balanceAfterD: this.numberFormatter.format(balanceData.balanceChangeData.endBalance),
            balanceBeforeH: this.numberFormatter.format(this.recalculateFromDaysToHours(balanceData.balanceChangeData.startBalance)),
            balanceAfterH: this.numberFormatter.format(this.recalculateFromDaysToHours(balanceData.balanceChangeData.endBalance)),
        }
    }

    recalculateFromDaysToHours(days) {
        return days == null ? null : days * this.workHoursPerDay
    }

    getFilename(selectedUserId, dateFrom, period) {
        const user = this.usersMap[selectedUserId]
        const dateFormatter = new DateFormat('MMM yyyy')
        const dateTo = period === 1 ? '' : ' - ' + dateFormatter.formatDate(new Date(dateFrom.getFullYear(), dateFrom.getMonth() + period - 1))
        return user.firstName + ' ' + user.lastName + ', ' +
               'Leave Time Details (' +
               dateFormatter.formatDate(dateFrom) + dateTo + ').csv'
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/reports/pastLeavesPage/CSVConverter.js